import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";
import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

const subscriptionsMetaInitialState = makeCrudBuilderInitialState(
  subscriptionsCrudStateConfig
);

export default subscriptionsMetaInitialState;
